import React, { useState, useEffect,useRef} from 'react';
import { configData } from "../config";
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import MinicartLength from './MinicartLength';
import ReactDOM from "react-dom/client";
import Loading from './Loading';

function PaypalPaymentNotify() {
    const[searchParams,setSearchParams] = useSearchParams();
    
    const app_url = configData.APP_URL;
    const navigate = useNavigate();
   
    useEffect(()=>{
      setTimeout(() => {
       PaypalSuccessNotify();
    }, 1500);
       
    },[])
   
    async function PaypalSuccessNotify() {
        
      const order_id = localStorage.getItem('order_id');
      const drupal_orderid = localStorage.getItem('drupal_orderid');
      const response = await fetch(app_url+'smwwcommercepayment/returnpalpayment?order_id='+order_id, {
              method: "GET",

      headers: {
        'Content-Type': 'application/json',
      },
              });
              const data = await response.json();
              if(data.data.result === "Success") {
                window.gtag("event", "purchase",  {
                  "transaction_id":data.data.order_details['transaction_id'],
                   "value":data.data.order_details['order_total'],
                    "shipping":data.data.order_details['shipping_amount'],
                   "currency": "USD",
                    "items": data.data.order_details['items']
                 });
      localStorage.removeItem("order_id");
      localStorage.removeItem("drupal_orderid");
      const root = ReactDOM.createRoot(document.getElementById("top-header-cart-icon"));
      root.render(<MinicartLength length={0} />);
     navigate("/smww/checkout/thankyou/"+drupal_orderid);
    }
             
      }
      return (
        <><div style={{ margin: "0 auto",maxWidth: 1170,width: "100%",textAlign: "center",fontSize: "35px",
          color: "#000",
          fontWeight: "900",
          marginTop: "20px" }}>Please wait until your order is complete.</div><Loading /></>
      );
}

export default PaypalPaymentNotify;